<template>
  <el-dialog
    :visible.sync="showDialog"
    class="dialog-quotedprice"
    title="立即报价"
    top="0"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleCloseDialog"
  >
    <el-form :model="formData" :rules="rules" ref="modifyForm">
      <el-form-item prop="mid_table_remark_017">
        <el-input
          class="custom-input"
          v-model="formData.mid_table_remark_017"
          placeholder="请输入报价金额"
          maxlength="11"
          clearable
        ></el-input>
      </el-form-item>
      <div class="quoted-tip">
        <div class="quoted-tip-item">1.一个ID一次可投一件任务，请谨慎报价</div>
        <div class="quoted-tip-item">2.中标后放弃将扣一颗星</div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button class="custom-button btn-e0e0e0" @click="handleCloseDialog"
      >取消
      </el-button
      >
      <el-button class="custom-button btn-determine" @click="handleSubmit"
      >确定
      </el-button
      >
    </div>
  </el-dialog>
</template>
<script>
import {numberValidator} from "@/assets/js/util";
import pageCommon from "@/utils/pagecommon";
import publicityApi from "@/api/publicity";
export default {
  name: "PublicityQuotedPrice",
  mixins: [],
  props: ['publicityInfo','userInfo'],
  data() {
    return {
      showDialog: false,
      formData: {
        mid_table_remark_017: "",
      },
      rules: {
        mid_table_remark_017: [
          {required: true, message: "请填写报价", trigger: "blur"},
          {validator: numberValidator, trigger: "blur"},
        ]
      },
      isRequesting: false,
    };
  },
  mounted() {
    let _this = this;
  },
  methods: {
    handleCloseDialog: function () {
      let _this = this;
      _this.showDialog = false;
    },
    handleSubmit: function () {
      let _this = this;
      if (_this.isRequesting) {
        return;
      }
      _this.isRequesting = true;
      if (this.publicityInfo.id_public_middle_table&&this.userInfo.id_public_user_info) {
        if(this.publicityInfo.mid_table_remark_010&&this.publicityInfo.mid_table_remark_010.split('-_-')[1]){
          if(Number(this.publicityInfo.mid_table_remark_010.split('-_-')[1])<Number(this.formData.mid_table_remark_017)){
            _this.$message.error('您的报价已经超过报价最大范围,'+this.publicityInfo.mid_table_remark_010.split('-_-')[1]+'将无法完成本次报价');
            _this.isRequesting = false;
            return
          }
        }
        _this.$refs["modifyForm"].validate((valid) => {
          if (valid) {
            let requestData = {
              isloading: true,
              id_public_user_info: this.userInfo.id_public_user_info,
              mid_table_remark_001:this.publicityInfo.mid_table_remark_001,
              mid_table_remark_002:this.publicityInfo.mid_table_remark_002,
              mid_table_remark_003:this.publicityInfo.mid_table_remark_003,
              mid_table_remark_004:this.publicityInfo.mid_table_remark_004,
              mid_table_remark_005:this.publicityInfo.mid_table_remark_005,
              mid_table_remark_006:this.publicityInfo.mid_table_remark_006,
              mid_table_remark_007:this.publicityInfo.mid_table_remark_007,
              mid_table_remark_008:this.publicityInfo.mid_table_remark_008,
              mid_table_remark_009:this.publicityInfo.mid_table_remark_009,
              mid_table_remark_010:this.publicityInfo.mid_table_remark_010,
              mid_table_remark_011:this.publicityInfo.mid_table_remark_011,
              mid_table_remark_012:this.publicityInfo.mid_table_remark_012,
              mid_table_remark_013:this.publicityInfo.id_public_middle_table,
              mid_table_remark_014:this.userInfo.nick_name,
              mid_table_remark_015:this.userInfo.weichat_img,
              mid_table_remark_016:this.userInfo.user_phone,
              mid_table_remark_017:this.formData.mid_table_remark_017,
              mid_table_remark_018:1801,
              mid_table_remark_021:2101,
              id_public_user_info:this.userInfo.id_public_user_info,
              is_online:0
            }
            pageCommon.apiRequestCommon(publicityApi, "insertPublicityOfferData", requestData).then(
              (res) => {
                _this.isRequesting = false;
                location.reload();
              },
              (err) => {
                _this.isRequesting = false;
                if (err.sysUserLoginError) {
                  _this.$message.error("系统异常，请稍后刷新重试！");
                } else {
                  _this.$message.error(err.data.msg);
                }
              }
            );
          } else {
            _this.isRequesting = false;
          }
        });
      } else {
        _this.$message.error("页面异常，请稍后刷新重试！");
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.dialog-quotedprice {
  /deep/ .el-dialog {
    position: absolute;
    width: 650px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
    .el-dialog__header {
      position: relative;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 30px 40px 40px;
      box-sizing: border-box;
      .el-dialog__title {
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #222222;
        line-height: 20px;
        text-align: left;
      }
      .el-dialog__headerbtn {
        position: relative;
        width: 16px;
        height: 16px;
        overflow: hidden;
        background: url("../../assets/icon_dialog_delete.png") no-repeat;
        background-size: 100% 100%;
        top: 0;
        right: 0;
        .el-dialog__close {
          &::before {
            content: none;
          }
        }
      }
    }
    .el-dialog__body {
      position: relative;
      width: 100%;
      padding: 0px 40px 0;
      box-sizing: border-box;
    }
    .el-form-item {
      margin-bottom: 30px;
    }
  }
  .quoted-tip{
    margin-bottom: 30px;
    font-size: 14px;
    text-align: left;
    line-height: 1.8em;
  }
  /deep/ .el-dialog__footer {
    position: relative;
    width: 100%;
    padding: 0;
    padding-bottom: 30px;
    /* padding-top: 0; */
    padding-right: 40px;
  }
  /deep/ .dialog-footer {
    display: flex;
    justify-content: flex-end;
    .custom-button {
      width: 80px;
      height: 46px;
      line-height: 46px;
      font-size: 16px;
      margin-left: 25px;
      &:first-child {
        margin-left: 0;
      }
    }
  }
}
</style>
